// ========= START: src/components/CharacterSelection.js =========

import React from 'react';
import { characters } from '../character_db';

function CharacterSelection({ onCharacterSelect }) {
  return (
    <div className="character-selection-screen">
      <div className="header-bar">
        <h2>Choose Your Teacher</h2>
      </div>
      <div className="character-grid">
        {characters.map((character) => (
          <div
            key={character.id}
            className="character-card"
            onClick={() => onCharacterSelect(character)}
          >
            <video
              className="character-video"
              src={character.profileVideo}
              autoPlay
              loop
              muted
              playsInline
            />
            <p className="character-name">{character.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CharacterSelection;

// ========= END: src/components/CharacterSelection.js =========